import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });
const COACH_KEY = "ss_coach_token";
export const getCoachToken = () => localStorage.getItem(COACH_KEY);
export const setCoachToken = (t) => (t ? localStorage.setItem(COACH_KEY, t) : localStorage.removeItem(COACH_KEY));
api.interceptors.request.use((cfg) => {
  const t = getCoachToken();
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const fileUrl = (id) => `${BACKEND}/api/files/${id}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || JSON.stringify(x)).replace(/^Value error, /, "")).join(" ");
  return String(d);
}

const DRAFTS_KEY = "ss_drafts";
export const listLocalDrafts = () => {
  try { return JSON.parse(localStorage.getItem(DRAFTS_KEY)) || []; } catch { return []; }
};
export const rememberDraft = (d) => {
  const rest = listLocalDrafts().filter((x) => x.id !== d.id);
  localStorage.setItem(DRAFTS_KEY, JSON.stringify([{ id: d.id, title: d.title, updated_at: d.updated_at }, ...rest].slice(0, 50)));
};
const TEAMS_KEY = "ss_teams";
const ADMIN_KEY = "ss_admin_token";
export const getAdminToken = () => localStorage.getItem(ADMIN_KEY);
export const setAdminToken = (t) => (t ? localStorage.setItem(ADMIN_KEY, t) : localStorage.removeItem(ADMIN_KEY));
export const adminApi = () => axios.create({ baseURL: `${BACKEND}/api`, headers: { Authorization: `Bearer ${getAdminToken()}` } });

const TOKENS_KEY = "ss_parent_tokens";
export const parentTokens = () => {
  try { return JSON.parse(localStorage.getItem(TOKENS_KEY)) || {}; } catch { return {}; }
};
export const forgetParentToken = (draftId) => { const t = parentTokens(); delete t[draftId]; localStorage.setItem(TOKENS_KEY, JSON.stringify(t)); };
export const saveParentToken = (draftId, token) => localStorage.setItem(TOKENS_KEY, JSON.stringify({ ...parentTokens(), [draftId]: token }));
export const listLocalTeams = () => {
  try { return JSON.parse(localStorage.getItem(TEAMS_KEY)) || []; } catch { return []; }
};
export const rememberTeam = (t) => {
  const rest = listLocalTeams().filter((x) => x.id !== t.id);
  localStorage.setItem(TEAMS_KEY, JSON.stringify([{ id: t.id, name: t.name }, ...rest].slice(0, 30)));
};
export const forgetDraft = (id) => localStorage.setItem(DRAFTS_KEY, JSON.stringify(listLocalDrafts().filter((x) => x.id !== id)));
